import { yupResolver } from "@hookform/resolvers/yup";
import { BlogQuoteContent } from "api/shop";
import { IDropdownOption, PaziaFormButton, PaziaInput, PaziaTextarea } from "components/atoms";
import { PaziaDropdown } from "components/atoms/PaziaDropdown/PaziaDropdown";
import { FormProvider, useForm } from "react-hook-form";
import * as yup from "yup";

interface BlogQuoteFormProps {
  onSubmit: (data: BlogQuoteFormValues) => void;
  onCancel: () => void;
  defaultValues?: BlogQuoteContent;
  isLoading?: boolean;
}

const VARIANT_OPTIONS: IDropdownOption[] = [
  { value: "default", label: "Domyślny" },
  { value: "highlight", label: "Wyróżniony" },
];

export const BlogQuoteForm = ({ onSubmit, onCancel, defaultValues, isLoading }: BlogQuoteFormProps) => {
  const methods = useForm<FormValues>({
    resolver: yupResolver(schema) as any,
    defaultValues: {
      quote: defaultValues?.quote ?? "",
      author: defaultValues?.author ?? "",
      source: defaultValues?.source ?? "",
      sourceUrl: defaultValues?.sourceUrl ?? "",
      variant: defaultValues?.variant ?? "default",
    },
  });

  const { handleSubmit } = methods;

  const handleFormSubmit = (data: FormValues) => {
    const formattedData: BlogQuoteFormValues = {
      quote: data.quote,
      author: data.author?.trim() ? data.author.trim() : undefined,
      source: data.source?.trim() ? data.source.trim() : undefined,
      sourceUrl: data.sourceUrl?.trim() ? data.sourceUrl.trim() : undefined,
      variant: (data.variant as "default" | "highlight") || "default",
    };
    onSubmit(formattedData);
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(handleFormSubmit)} className="grid gap-4">
        <PaziaTextarea name="quote" label="Cytat" required />
        <PaziaInput name="author" label="Autor (opcjonalnie)" />
        <PaziaInput name="source" label="Źródło (opcjonalnie)" />
        <PaziaInput name="sourceUrl" label="Link do źródła (opcjonalnie)" placeholder="https://..." />
        <PaziaDropdown name="variant" label="Wariant" options={VARIANT_OPTIONS} />

        <div className="flex justify-end gap-2 border-t border-slate-200 pt-4 dark:border-slate-600">
          <button
            type="button"
            onClick={onCancel}
            className="rounded-lg border border-slate-300 px-4 py-2 text-slate-700 transition-colors hover:bg-slate-50 dark:border-slate-600 dark:text-slate-300 dark:hover:bg-slate-700"
          >
            Anuluj
          </button>
          <PaziaFormButton disabled={isLoading} />
        </div>
      </form>
    </FormProvider>
  );
};

const schema = yup
  .object({
    quote: yup.string().required("Cytat jest wymagany"),
    author: yup.string().optional(),
    source: yup.string().optional(),
    sourceUrl: yup.string().optional(),
    variant: yup.string().optional(),
  })
  .required();

interface FormValues {
  quote: string;
  author?: string;
  source?: string;
  sourceUrl?: string;
  variant?: string;
}

export interface BlogQuoteFormValues {
  quote: string;
  author?: string;
  source?: string;
  sourceUrl?: string;
  variant?: "default" | "highlight";
}
